import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

/* --------------------------------- Fields --------------------------------- */

  xpandStatus = false;
  panelOpenState: any;
  // MBOILE-MENU
  customNavCollapsedHeight = '30px';
  customNavExpandedHeight = '30px';
  listNone = false;

  isOpen = false;
  logoHidden = false;
  megaMenuShow = false;
  opened!: boolean;
  isSticky: boolean = false;
  isScrollTop: boolean = false;
  customCollapsedHeight = '35px';
  customExpandedHeight = '35px';
  langControl = new FormControl('en');
  public appointmentForm!: FormGroup;

  @HostListener('window:scroll', [])
  checkScroll(): void {
    this.isSticky = window.pageYOffset >=50;
    this.isScrollTop = window.pageYOffset >= 50;
  }


/* ------------------------------- Constructor ------------------------------ */

  constructor(
    private _fb: FormBuilder,
    public router: Router,
    private route: ActivatedRoute
  ) { }
  toggleMenu() {
    this.opened = !this.opened;
  }

  menuToggle(): void {
    this.megaMenuShow = !this.megaMenuShow;
  }

/* ---------------------------- Life cycle hooks ---------------------------- */

  ngOnInit(): void {
     this.appointmentForm = this._fb.group ({
      name: [null, [Validators.required]],
      department: [null, [Validators.required]],
      fullName: [null, [Validators.required]],
      email: [null, [Validators.required]],
      phoneNo: [null, [Validators.required]],
      appointment_date: [null, [Validators.required]],
     });
     this.route.queryParamMap.subscribe(data=>{
       this.langControl.setValue(data.get('lang') ?? 'en');
     });
  }

  scrollTop(): void {
    (function smoothscroll() {
      var currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 10) {
        window.scrollTo(0, 0);
      }
    })();
  }
  setLanguage(lang: string){
    this.router.navigate([], {queryParams: {
      lang
    }})
  }
}
